import { forwardRef, type Ref, type SVGProps } from "react";
const IconLocationArrowOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M27.424 2.902c1.19-.56 2.48.559 2.095 1.817l-7.642 24.954c-.454 1.481-2.574 1.41-2.927-.097l-2.68-11.434-11.7-1.413c-1.512-.183-1.841-2.231-.462-2.88L27.424 2.903zm-.136 2.273L6.48 14.945l10.364 1.252c.632.076 1.15.54 1.295 1.16l2.349 10.02z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconLocationArrowOutlineSVG);
ForwardRef.displayName = "IconLocationArrowOutline";
export { ForwardRef as IconLocationArrowOutline };
